import { render, staticRenderFns } from "./newshop.vue?vue&type=template&id=7afe386e&scoped=true&"
import script from "./newshop.vue?vue&type=script&lang=js&"
export * from "./newshop.vue?vue&type=script&lang=js&"
import style0 from "./newshop.vue?vue&type=style&index=0&id=7afe386e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7afe386e",
  null
  
)

export default component.exports